<template>
  <picture class="main-bg">
    <img class="main-bg__img" src="~@/assets/img/head-bg.jpg" alt="" />
  </picture>
</template>

<script>
export default {
  name: "MainBg"
};
</script>

<style lang="scss">
.main-bg {
  position: absolute;
  top: -130px;
  left: 50%;
  z-index: -1;
  transform: translateX(-50%);
  width: 100%;
  min-width: 1920px;

  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
  }

  &::before {
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(#000a25, 0.6), #000a25);
  }
  &::after {
    height: 65%;
    transform: rotate(180deg);
    background: linear-gradient(to top, #000a25 0%, rgba(0, 0, 0, 0) 100%);
    bottom: auto;
    top: 100%;
  }

  &__img {
    width: 100%;
  }
}
</style>
